import { inject } from 'aurelia-framework';
import { EventAggregator } from 'aurelia-event-aggregator';
import { CustomerService } from 'pages/quote-setup/customers/service';
import { DialogService } from 'aurelia-dialog';
import { formatTableLink, creatTableButton } from 'resources/utility';
import { PLATFORM } from 'aurelia-pal';
import toastr from 'toastr';

@inject(CustomerService, DialogService, EventAggregator)
export class Customers {
    constructor(customerService, dialogService, ea) {
        this.ea = ea;
        this.customerService = customerService;
        this.dialogService = dialogService;

        this.columns = [
            { dataField: 'name', sortOrder: 'asc', cellTemplate: (container, options) => formatTableLink({ container, containerOptions: options, callback: this.edit }) },
            { dataField: 'address' },
            { dataField: 'city' },
            { dataField: 'state', caption: 'State/Province' },
            { dataField: 'zip' },
            { dataField: 'country' },
            { dataField: 'sga' },
            { dataField: 'profit' },
            { dataField: 'contact' },
            { dataField: 'phone' },
            { caption: 'Actions', cellTemplate: (container, options) => creatTableButton({ container, containerOptions: options, style: 'danger', label: 'Delete', action: this.delete }), allowExporting: false }
        ];

        this.subscription = this.ea.subscribe('customers:updated', () => {
            this.grid.refresh();
        });
    }

    deactivate () {
        this.subscription.dispose();
    }

    delete = (customer) => {
        this.dialogService.open({ viewModel: PLATFORM.moduleName('resources/elements/modals/confirm/index') }).whenClosed(async response => {
            if (!response.wasCancelled) {
                await this.customerService.delete(customer.id);
                this.grid.refresh();
                toastr.success('Customer was deleted!');
            }
        });
    };

    add() {
        this.dialogService.open({ viewModel: PLATFORM.moduleName(this.customerService.editor)});
    }

    edit = (data) => {
        this.dialogService.open({ viewModel: PLATFORM.moduleName(this.customerService.editor), model: { id: data.id } });
    };
}